import { ArrowCircleRight } from "../../../svgIcons"
import { Img } from "../../../layout/Img"
import { LinkField } from "../../linkField"

export const Cards = ({ items }) => {
  return (
    <div className="container flex flex-col items-center justify-center w-11/12 mx-auto md:w-9/12">
      <div className="flex-wrap md:flex">
        {items.map((item) => (
          <div
            key={item.uid}
            className="w-full my-1 mt-10 cursor-pointer md:w-1/2 lg:my-4 lg:px-4 lg:w-1/3"
          >
            <LinkField {...item.cardLinkField}>
            <article className="overflow-hidden duration-500 transform rounded-lg shadow-lg cursor-pointer card-hover group hover:bg-primary ">
                <Img
                  className="card-image"
                  image={item.cardCoverPicture[0]}
                />
                <header className="flex flex-col h-48 p-8 leading-tight">
                  <h3 className="mt-5 font-semibold text-md 2xl:text-2xl text-dark group-hover:text-white text-secondary">
                    {item.cardHeading}
                  </h3>

                  <div
                    className="mt-5 text-sm group-hover:text-white text-secondary"
                    dangerouslySetInnerHTML={{ __html: item.cardContent }}
                  />
                </header>

                <footer className="flex justify-end gap-2 mx-3 mb-5 cursor-pointer group">
                  <div className="px-5 py-2 text-xs font-semibold text-white ">
                    <ArrowCircleRight className="w-6 h-6 text-secondary group-hover:text-white" />
                  </div>
                </footer>
              </article>
            </LinkField>
          </div>
        ))}
      </div>
    </div>
  )
}
